import { Box, Flex, Heading, Text, Button, VStack, Icon } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { FaQuestionCircle } from 'react-icons/fa';

const Error404 = () => {
    const navigate = useNavigate();

    return (
        <Flex
            minH="100vh"
            align="center"
            justify="center"
            bg="gray.50"
            px={4}
        >
            <Box
                maxW="md"
                w="full"
                bg="white"
                shadow="none"
                rounded="lg"
                p={8}
                textAlign="center"
            >
                <VStack spacing={6}>
                    <Icon
                        as={FaQuestionCircle as React.ElementType}
                        w={16}
                        h={16}
                        color="blue.500"
                    />

                    <VStack spacing={2}>
                        <Heading size="2xl" color="gray.800">
                            404
                        </Heading>
                        <Heading size="lg" color="gray.700">
                            Page Not Found
                        </Heading>
                        <Text color="gray.600" fontSize="md">
                            The page you're looking for doesn't exist or has been moved.
                        </Text>
                    </VStack>

                    <VStack spacing={3} w="full">
                        <Button
                            colorScheme="blue"
                            size="lg"
                            w="full"
                            onClick={() => navigate('/')}
                        >
                            Go to Dashboard
                        </Button>
                        <Button
                            variant="outline"
                            size="lg"
                            w="full"
                            onClick={() => navigate(-1)}
                        >
                            Go Back
                        </Button>
                    </VStack>
                </VStack>
            </Box>
        </Flex>
    );
};

export default Error404; 